const common_error_id = {
    address: "Alamat wajib diisi",
    bank_acc: "Akun bank wajib diisi",
    category: "Kategori barang wajib diisi",
    customer: "Pelanggan wajib diisi",
    date: "Tanggal wajib diisi",
    date_due: "Tanggal jatuh tempo wajib diisi",
    district: "Kelurahan wajib diisi",
    download: "Gagal mengunduh file",
    email: "Email wajib diisi",
    email_valid: "Format email tidak valid",
    file: "File wajib diisi",
    file_error: "Gagal mengunduh file",
    name: "Nama wajib diisi",
    payment_method: "Metode pembayaran wajib diisi",
    pass: "Kata sandi wajib diisi",
    pass_valid: "Format kata sandi tidak valid",
    pass_conf: "Konfirmasi kata sandi wajib diisi",
    pass_conf_match: "Konfirmasi kata sandi tidak cocok",
    phone: "Nomor telepon wajib diisi",
    province: "Provinsi wajib diisi",
    sub_province: "Kota wajib diisi",
    sub_district: "Kecamatan wajib diisi",
    supplier: "Pemasok wajib diisi",

    login: "Email atau kata sandi salah",

    // transaction
    cost1_name: "Nama biaya wajib diisi",
    cost2_name: "Nama potongan wajib diisi",

    goods: "Barang wajib diisi",
    goods_data: "Data barang wajib diisi",
    goods_min: "Minimal 1 barang",
    goods_qty_zero: "Jumlah barang tidak boleh 0",

    sn: "Nomor seri wajib diisi",
    sn_qty: "Kuantitas melebihi stok tersedia",
    sn_same: "Nomor seri duplikat",
    sn_used: "Nomor seri sudah digunakan",

    warehouse: "Gudang wajib diisi",
    warehouse_min: "Minimal 1 gudang",
    warehouse_orig: "Gudang asal wajib diisi",
    warehouse_dest: "Gudang tujuan wajib diisi",

    inv_data: "Data invoice wajib diisi",
    inv_min: "Minimal 1 invoice"
}

export default common_error_id;